import { render, staticRenderFns } from "./ProductosModificadores.vue?vue&type=template&id=a7bf8e38"
import script from "./ProductosModificadores.vue?vue&type=script&lang=js"
export * from "./ProductosModificadores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports